import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=ad964942&scoped=true"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"
import style0 from "./Website.vue?vue&type=style&index=0&id=ad964942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad964942",
  null
  
)

export default component.exports